<script>
    import dressing from "@intellectability/platform-common";
    import {ChoosePersonModal, ExportButtons, FlexList, Icon} from "@intellectability/platform-common/sv";
    import {create_security_error} from "@intellectability/platform-common/utils";
    import {Breadcrumb, BreadcrumbItem} from "@sveltestrap/sveltestrap";
    import {onMount} from "svelte";

    let loading = $state(true);

    // flexlist data
    let bradenScales = $state.raw([]);

    // filter options
    let selectedSignedDate = $state("");
    let selectedIsCompleted = $state("");
    let selectedScore = $state("");
    let selectedName = $state("");

    // pagination
    let pagination = $state({
        show: true,
        page: 1,
        limit: 10,
        recordsFiltered: null,
        recordsTotal: null,
        pageLengthMenu: [10, 25, 50, 100, 500]
    });

    // sort
    let sort = $state({
        field: "name",
        order: "asc"
    });

    let columns = $derived([
        {
            name: "Person",
            field: "name",
            width: "",
            sortedBy: sort.field === "name" ? sort.order : "",
            sortable: true,
            collapse: false,
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (value) {
                selectedName = value;
            }
        },
        {
            name: "Date Signed",
            field: "signed",
            width: "",
            sortedBy: sort.field === "signed" ? sort.order : "",
            sortable: true,
            filterable: true,
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (value) {
                selectedSignedDate = value;
            }
        },
        {
            name: "Completed",
            field: "complete",
            width: "",
            sortedBy: sort.field === "complete" ? sort.order : "",
            sortable: true,
            filterable: true,
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (value) {
                selectedIsCompleted = value;
            }
        },
        {
            name: "Score",
            field: "score",
            width: "",
            sortable: true,
            sortedBy: sort.field === "score" ? sort.order : "",
            filterable: true,
            filterType: "text",
            filterPlaceholder: "Search",
            onfilter: function (value) {
                selectedScore = value;
            }
        },
        {
            name: "Actions",
            width: "110px",
            buttons: [
                {
                    icon: "file-pdf",
                    tooltip: "Generate PDF",
                    className: "btn p-1 border-0 shadow-none",
                    styles: "",
                    action: function (row) {
                        const {id} = row;
                        pdfForm(id);
                    }
                },
                {
                    icon: "pencil",
                    tooltip: "Edit",
                    className: "btn p-1 border-0 shadow-none",
                    styles: "",
                    action: function (row) {
                        const {id} = row;
                        editForm(id);
                    },
                    disable: function (row) {
                        return (row.allow_edit === "Y" && canManage) === false;
                    }
                },
                {
                    icon: "times-circle",
                    tooltip: "Delete visit",
                    className: "btn link-danger p-1 shadow-none",
                    styles: "",
                    action: function (row) {
                        const {id} = row;
                        deleteForm(id);
                    },
                    disable: function (row) {
                        return (row.allow_edit === "Y" && canDelete) === false;
                    }
                }
            ]
        }
    ]);

    onMount(function load() {
        if (userSecurity.loggedIn === true) {
            // user has access to the provider list
            if (hasAccess(BRADEN_SCALE_GLOBAL_LIST)) {
                const err = create_security_error("App.svelte", "BradenScaleList", BRADEN_SCALE_GLOBAL_LIST);
                dressing.api.report_security_error(err).then(() => dressing.api.logout());
            }
            loading = false;
        }
    });

    function fetch_list() {

        if (userSecurity.loggedIn === true) {

            if (!hasAccess(BRADEN_SCALE_GLOBAL_LIST)) {
                return;
            }

            const filter_query = {
                name: selectedName || null,
                signed: selectedSignedDate || null,
                complete: selectedIsCompleted || null,
                score: selectedScore || null
            };

            const sort_query = {
                sort: sort.field || null,
                order: sort.order || null
            };

            const page_query = {
                page: pagination.page || null,
                limit: pagination.limit || null
            };

            // TODO: get braden scale endpoint created
            dressing.get("/braden_scale_list", {
                params: Object.assign(filter_query, {...sort_query, ...page_query})
            }).then(({data: res}) => {
                const {success, data} = res;
                if (success === true) {
                    const {records: b, recordsFiltered, recordsTotal} = data;
                    if (Array.isArray(b)) {
                        bradenScales = b;
                        pagination.recordsFiltered = recordsFiltered;
                        pagination.recordsTotal = recordsTotal;
                    }
                }
            });
        }
    }

    function deleteForm(/** @type {string} */ id) {
        if (canDelete) {
            dressing.axi.delete(`/api/v1/cm/braden_scale_forms/${id}`).then(
                ({data: res}) => {
                    if (res.success === true) {
                        fetch_list();
                    }
                }
            );
        }
    }

    function editForm(id) {
        if (canManage) {
            window.location.href = `index.php?action=${BRADEN_SCALE_MANAGE}&id=${id}`;
        }
    }

    function pdfForm(id) {
        window.open(`index.php?action=${BRADEN_SCALE_PDF}&id=${id}`);
    }

    function newForm(/** @type {{value:string, text:string}} */ person) {
        if (canManage && person?.value.length > 0) {
            window.location.href = `/index.php?action=${BRADEN_SCALE_MANAGE}&cid=${person.value}&id=NEW`;
        }
    }


</script>
<!-- Breadcrumbs -->
<Breadcrumb divider={" "} class="breadcrumbs mb-3">
    <BreadcrumbItem>
        <a href="/index.php?action=30000">
            <Icon icon="briefcase" class="mr-1"/>
            Braden scale
        </a>
    </BreadcrumbItem>
    <BreadcrumbItem class="mx-3">
        <Icon icon="chevron-right"/>
    </BreadcrumbItem>
    <BreadcrumbItem>
        list
    </BreadcrumbItem>
</Breadcrumb>
<!-- Page Title -->
<h1>
    <Icon icon="briefcase"/>
    Braden Scale Forms
</h1>
<!-- Export Buttons -->
<div class="d-flex w-100 justify-content-end mb-3">
    <ExportButtons show={["excel", "pdf"]}
                   href="ajax/default/ajax.download_list.php?list={BRADEN_SCALE_GLOBAL_LIST}"/>
</div>
<!-- TABLE -->
<FlexList loading={loading}
          pagerConfig={pagination}
          onpagechange={(page) => pagination.page = page}
          onsort={(field, order) => {sort = {field, order};}}
          onpagelengthchange={(newLimit) => pagination.limit = newLimit}
          {columns}
          data={bradenScales}>
</FlexList>
<ChoosePersonModal context="braden_scale" confirmButtonText="Create New Braden Scale" onselect={newForm}/>